module.exports = __webpack_public_path__ + "static/media/599.705493(7).a2024954.pdf";